import React from "react";
import "./FormFields.css";

const TextField = React.forwardRef(({
  label,
  value,
  onChange,
  type = "text",
  placeholder = "",
  required = false,
  readOnly = false,
  width = "100%",
  style = {},
  className = "",
  labelStyle = {},
  inputStyle = {},
  ...props
}, ref) => {
  // Determine width class
  const getWidthClass = () => {
    if (width === "100%") return "form-field-width-100";
    if (width === "50%") return "form-field-width-50";
    if (width === "40%") return "form-field-width-40";
    if (width === "30%") return "form-field-width-30";
    return ""; // default 30% is already in .form-text-field
  };

  const inputClassName = `form-text-field ${getWidthClass()}`.trim();
  const labelClassName = "form-field-label";

  return (
    <div className={`form-group ${className}`} style={style}>
      <label className={labelClassName} style={labelStyle}>
        {label}
        {required && (
          <span className="form-field-required">
            *
          </span>
        )}
      </label>
      <input
        ref={ref}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        readOnly={readOnly}
        required={required}
        className={inputClassName}
        style={inputStyle}
        {...props}
      />
    </div>
  );
});

TextField.displayName = "TextField";

export default TextField;
